import type { Transition } from "framer-motion";

export const easings = {
  emphasized: [0.32, 0.72, 0, 1] as const,
  out: [0.32, 0, 0.67, 0] as const,
};

export const springs = {
  gentle: { type: "spring", stiffness: 260, damping: 28 } satisfies Transition,
  snappy: { type: "spring", stiffness: 400, damping: 30 } satisfies Transition,
  soft: { type: "spring", stiffness: 180, damping: 26 } satisfies Transition,
};

export const durations = {
  enter: 0.24,
  exit: 0.18,
  micro: 0.12,
};
